<template>
  <div
    style="width: 100%; height: 100%; background: #f5f7fa; min-width: 1200px"
  >
    <el-dialog
      :title="`${this.app.id ? '修改名称和图标' : '新增应用'}`"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="dialogBeforeClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="form" label-width="80px" label-position="top">
          <el-form-item label="名称">
            <el-input
              v-model="app.name"
              placeholder="给应用命名，例如“客户管理系统”"
            ></el-input>
          </el-form-item>

          <el-form-item label="图标">
            <el-popover placement="bottom" width="320px" trigger="click">
              <div
                class="center icon"
                slot="reference"
                :style="{ backgroundImage: appColors[app.bgColor] }"
              >
                <svg-icon :icon-class="app.icon + ''"></svg-icon>
              </div>
              <div class="appColorsBox">
                <div class="top">
                  <span
                    v-for="(item, index) in appColors"
                    :key="item"
                    :style="{ backgroundImage: item }"
                    :class="{ active: index === app.bgColor }"
                    @click="app.bgColor = index"
                  ></span>
                </div>
                <div class="body">
                  <div v-for="item in 20" :key="item">
                    <div
                      class="center body-icon"
                      :style="{ backgroundImage: appColors[app.bgColor] }"
                      @click="app.icon = item"
                      :class="{ active: item === app.icon }"
                    >
                      <svg-icon :icon-class="item + ''"></svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="submit" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <div class="header between">
      <el-image
        style="width: 173px; height: 30px; cursor: pointer"
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/logo1-140105423.png"
        @click="$router.push({ path: '/site' })"
      ></el-image>
      <Photo></Photo>
    </div>

    <div class="content">
      <div class="content-main">
        <div class="content-bg">
          <div>{{ toDay }}好，{{ user.name }}</div>
          <div>欢迎进入工作台，开始一天的工作吧！</div>
          <el-image
            style="
              width: 90%;
              height: 169px;
              position: absolute;
              left: 0;
              top: 0;
              z-index: -1;
            "
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/矩形 507@2x-171344190.png"
          ></el-image>
          <el-image
            style="
              width: 653px;
              height: 169px;
              position: absolute;
              right: 0;
              top: 0;
            "
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/底图@2x (1)-171418972.png"
          ></el-image>
        </div>
        <div class="content-box">
          <div>
            <div>
              <span>最近使用</span>
              <div class="flex" style="padding-top: 26px; gap: 4px">
                <div
                  v-for="item in recently"
                  :key="item.id"
                  class="flex hoverBox"
                  style="
                    width: 180px;
                    gap: 14px;
                    align-items: center;
                    padding: 14px;
                  "
                  @click="toForm(item)"
                >
                  <div class="center" slot="reference">
                    <svg-icon
                      :icon-class="item?.pcLogo || 1"
                      style="font-size: 24px"
                      :style="{ color: pcColors[item?.bgColor || 0] }"
                    ></svg-icon>
                  </div>
                  <div
                    style="color: #141e31; font-size: 14px; line-height: 18px"
                  >
                    {{ item.formName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <span>我的待办</span>
              <div style="padding-top: 6px" class="flex">
                <div
                  class="center hoverBox"
                  style="width: 540px; height: 114px"
                  @click="toTodo('todo')"
                >
                  <el-image
                    style="width: 54px; height: 54px"
                    src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/待办-162751825.png"
                  ></el-image>
                  <div style="color: #141e31; margin-left: 36px">
                    <div style="font-size: 18px; line-height: 24px">
                      我的待办
                    </div>
                    <div
                      style="color: #141e31; font-size: 34px; line-height: 40px"
                    >
                      {{ todoNum }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 1px;
                    height: 80px;
                    background: #ebecee;
                    margin-top: 17px;
                    margin-left: 12px;
                    margin-right: 107px;
                  "
                ></div>
                <div
                  v-for="item in flowArr"
                  :key="item.name"
                  style="flex-direction: column; width: 250px; height: 114px"
                  class="center hoverBox"
                  @click="toTodo(item.path)"
                >
                  <el-image
                    :src="item.icon"
                    style="width: 50px; height: 50px"
                  ></el-image>
                  <div
                    style="
                      margin-top: 12px;
                      color: #141e31;
                      font-size: 16px;
                      line-height: 24px;
                    "
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div style="position: relative">
              <span>我的应用</span>
              <div
                style="
                  position: absolute;
                  top: 0px;
                  right: 0;
                  display: flex;
                  height: 32px;
                  gap: 16px;
                "
              >
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  style="border-radius: 50px"
                  @click="moduleAdd('add')"
                  >新建应用</el-button
                >
              </div>
              <div style="padding-top: 4px" class="flex">
                <div
                  v-for="item in appArr"
                  :key="item.id"
                  class="center appHoverBox"
                  style="
                    width: 208px;
                    height: 144px;
                    flex-direction: column;
                    gap: 12px;
                    position: relative;
                  "
                  @click="toModule(item)"
                >
                  <el-dropdown
                    style="position: absolute; top: 12px; right: 12px"
                    @command="handleCommand($event, item)"
                    placement="bottom"
                  >
                    <div>
                      <svg-icon
                        icon-class="setting"
                        class="settingSvg"
                        @click.stop
                      ></svg-icon>
                    </div>
                    <el-dropdown-menu
                      slot="dropdown"
                      :append-to-body="false"
                      style="width: 200px"
                    >
                      <el-dropdown-item command="edit"
                        >修改名称和图标</el-dropdown-item
                      >
                      <el-dropdown-item style="color: #ff4f4f" command="delete"
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-image
                    style="width: 46px; height: 46px"
                    :src="item.icon"
                    v-if="!item.bgColor"
                  ></el-image>
                  <div
                    v-else
                    class="center body-icon"
                    style="width: 46px; height: 46px"
                    :style="{ backgroundImage: appColors[item.bgColor] }"
                  >
                    <svg-icon :icon-class="item.icon + ''"></svg-icon>
                  </div>
                  <div
                    style="color: #141e31; font-size: 14px; line-height: 18px"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getModuleList,
  recentUse,
  moduleAddOrEdit,
  moduleDelete,
} from "@/api/module";
import Photo from "@/components/Photo.vue";
import { getTodoNum } from "@/api/setProcess";

export default {
  components: { Photo },
  data() {
    return {
      // appName: "",
      recently: [],
      flowArr: [
        {
          name: "我发起的",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/我发起的@2x-162710761.png",
          path: "myTodo",
        },
        {
          name: "待阅",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/07/待阅@2x-162710783.png",
          path: "myJoin",
        },
      ],
      appArr: [],
      dialogVisible: false,
      appColors: [
        "linear-gradient(135deg,#f8c54f,#f0a800)",
        "linear-gradient(135deg,#f18585,#eb5050)",
        "linear-gradient(135deg,#7ed49a,#46c26f)",
        "linear-gradient(135deg,#63d1e8,#00aed1)",
        "linear-gradient(135deg,#77abf4,#2f7deb)",
        "linear-gradient(135deg,#a782f0,#7e47eb)",
      ],
      pcColors: ["#FA8118", "#56CA56", "#0AB1F7", "#107FFF", "#686FFF"],
      app: {
        name: "",
        icon: 1,
        bgColor: 0,
      },
      colorActive: 0,
      iconActive: 0,
    };
  },
  computed: {
    todoNum() {
      return this.$store.state.user.todoNum;
    },
    user() {
      return this.$store.getters.userInfo;
    },
    toDay() {
      // 获取当前日期  过12点返回下午 中午12点前返回上午
      const hour = new Date().getHours();
      if (hour < 12) {
        return "上午";
      } else {
        return "下午";
      }
    },
  },
  created() {
    this.info();
    this.todoNumFn();
    this.getRecentUse();
  },
  methods: {
    async submit() {
      await moduleAddOrEdit(this.app);
      this.$message.success(
        `${this.app.name}${this.app.id ? "修改" : "添加"}成功`
      );
      this.dialogBeforeClose();
      this.info();
    },
    moduleAdd(str) {
      if (str === "add") {
        this.dialogVisible = true;
      }
    },
    dialogBeforeClose() {
      this.dialogVisible = false;
      this.app = {
        name: "",
        icon: 1,
        bgColor: 0,
      };
    },
    handleCommand(command, item) {
      this.app = { ...item, bgColor: item.bgColor ? item.bgColor : 0 };
      if (command === "edit") {
        console.log(item);
        this.dialogVisible = true;
      } else {
        this.$prompt("请输入当前应用名称", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: (value) => {
            console.log(value);
            if (value !== item.name) {
              return false;
            }
            return true;
          },
          inputErrorMessage: "名称不一致",
        })
          .then(async ({ value }) => {
            await moduleDelete(item.id);
            this.$message({
              type: "success",
              message: "已删除" + value,
            });
            this.info();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          });
      }
    },
    toForm(item) {
      const menuBar = this.appArr.find((e) => e.id === item.moduleId);
      if (!menuBar) {
        return this.$message.error("应用不存在");
      }
      localStorage.setItem("menuBar", JSON.stringify(menuBar));
      this.$router.push("/home?code=" + item.id);
    },
    toModule(item) {
      localStorage.setItem("menuBar", JSON.stringify(item));
      this.$router.push("/home");
    },
    async getRecentUse() {
      const res = await recentUse();
      this.recently = res.data;
    },
    async info() {
      let res = await getModuleList();
      this.$store.commit("formData/setModuleList", res.data);
      this.appArr = res.data;
    },

    async todoNumFn() {
      let res = await getTodoNum({
        sort: "",
      });
      if (res.code === 200 && res.data && res.data.length > 0) {
        const todoNum = res.data.reduce((oldNum, newNum) => {
          return oldNum + newNum.num;
        }, 0);
        this.$store.commit("user/setTodoNum", todoNum);
      }
    },
    toTodo(str) {
      this.$router.push("/backlog?type=" + str);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 64px;
  background: #fff;
  padding: 0 20px;
}

.content {
  width: 100%;
  height: calc(100vh - 64px);
  background: #f5f7fa;
  .content-main {
    position: relative;
    overflow: auto;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 100%;
    .content-bg {
      width: 100%;
      z-index: 1;
      height: 169px;
      padding-left: 32px;
      padding-top: 42px;
      & > div {
        &:nth-child(1) {
          font-size: 24px;
          color: #3d3d3d;
          line-height: 32px;
          font-weight: 500;
        }
        &:nth-child(2) {
          font-size: 16px;
          color: #7c7d8d;
          line-height: 32px;
          margin-top: 6px;
        }
      }
    }
    .content-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 0 32px;
      & > div {
        border-radius: 6px;
        background: #fff;
        padding: 20px 34px;
        margin-bottom: 16px;
        span {
          color: #141e31;
          font-size: 18px;
          line-height: 32px;
          font-weight: 500;
          &::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 16px;
            background: #107fff;
            margin-right: 10px;
          }
        }
        &:nth-child(1) {
          height: 186px;
          margin-top: 132px;
        }
        &:nth-child(2) {
          height: 206px;
        }
        &:nth-child(3) {
          height: 228px;
        }
      }
    }
  }
}

.hoverBox {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    background: #f5f6f8;
    border-radius: 4px;
  }
}

.appHoverBox {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  .settingSvg {
    display: none;
    color: #828791;
    &:hover {
      color: #107fff;
    }
  }
  &:hover {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px 4px 4px 4px;
    .settingSvg {
      display: block;
    }
  }
}

.icon {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  cursor: pointer;
  .svg-icon {
    width: 40px;
    height: 40px;
    color: #fff;
  }
}

.appColorsBox {
  padding: 8px;
  .top {
    display: flex;
    gap: 16px;
    padding-bottom: 18px;
    padding-left: 8px;
    span {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      cursor: pointer;
      box-sizing: border-box;
      &.active {
        border: 2px solid #b0d5ff;
      }
    }
  }
}
.body {
  width: 300px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  background: #f5f6f8;
  padding: 10px;
  border-radius: 4px;
}

.body-icon {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  .svg-icon {
    width: 30px;
    height: 30px;
    color: #fff;
  }
  &.active {
    border: 2px solid #b0d5ff;
  }
}

/deep/.el-input__inner {
  height: 32px;
  border-radius: 50px;
}

// /deep/ .el-input__icon {
//   line-height: 32px;
// }
</style>